import { render, staticRenderFns } from "./kdApprovalRecord.vue?vue&type=template&id=06e285f8&scoped=true"
import script from "./kdApprovalRecord.vue?vue&type=script&lang=js"
export * from "./kdApprovalRecord.vue?vue&type=script&lang=js"
import style0 from "./kdApprovalRecord.vue?vue&type=style&index=0&id=06e285f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e285f8",
  null
  
)

export default component.exports